import React, {useCallback, useState} from 'react'
import { useTranslation } from 'react-i18next';
import { FilterContainer, InputFilter, Option, TD, SelectFilter } from '../../../styles/Table.styled';
import DateFilter from '../../UI/DateFilter/DateFilter';
import { PrimaryBtnOutlineAction, BtnFilter } from '../../../styles/Common';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { CTooltip } from '../../UI/CTooltip/CTooltip';
import { useTheme } from 'styled-components';
function TableFilters(props) {
    const { showFilters, entitiesFilters, filtersChange, applyFilters,resetFilters,columns} = props;
    const [show, setShow] = useState(null)
    const [dateField, setDateField] = useState('')
    const {t} = useTranslation();

    const inputChangeHandler = (e) => {
        let key = e.target.name;
        let newFilters = {
            ...entitiesFilters,
            [key]: e.target.value
        }
        filtersChange(newFilters);
        applyFilters(newFilters)
    }
    const formatDate = useCallback((date) => { 
        if (date !== null && date.valueOf() > 0){
            let newDate = new Date(date);
            let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()
            let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)
        return day + '/' + month + '/' + newDate.getFullYear()
        }else return null;    
    }, [])

    const closeModalHandler = () => {
        setShow(false);
    }

    const dateShowHandler = (field) => {
        setShow({
            [field]: true
        })
        setDateField(field);
    }

    const convertDate = (date) => {
        let dateArray = date.split(':');
        return [formatDate(+dateArray[0]) , formatDate(+dateArray[1])]
    }

    let [dateInputValue,setDateInputValue] = useState({
        creationDate: entitiesFilters?.creationDate ? convertDate(entitiesFilters.creationDate) : ''
    });

    const getCreationdate = () => {
        return entitiesFilters?.creationDate ? convertDate(entitiesFilters.creationDate) : [];
    }

    const dateChangeHandler = (date) => {
        setDateInputValue({
            ...dateInputValue,
            [dateField]: formatDate(date.startDate) + '-' + formatDate(date.endDate)
        })
        let key = date.field;
        let newFilters = {
            ...entitiesFilters,
            [key]: date.startDate.getTime() + ':' + date.endDate.getTime()
        }
        filtersChange(newFilters)
        applyFilters(newFilters);
    }

    const dateResetHandler = (field) => {
        setDateInputValue({
            ...dateInputValue,
            [field]: ''
        })
        let newFilters = {
            ...entitiesFilters,
            [field]: null
        }
        filtersChange(newFilters)
        applyFilters(newFilters);
    }

    
   
   
    return (
        <>
            <tr style={{display: showFilters ? 'table-row' : 'none'}}>
                <TD></TD> 
                <TD style={{
                    display: !columns.filter(column => column.field == "raisonSociale")[0].show == true && 'none'
                }}>
                    <FilterContainer>
                        <InputFilter
                            placeholder={t("invoiceList:entityName", "Nom")}
                            onChange={(e) => inputChangeHandler(e)}
                            value={entitiesFilters?.raisonSociale || ''}
                            name="raisonSociale"
                            type="text"
                            autoComplete="off"
                        />
                    </FilterContainer>
                </TD>
                <TD style={{ display: !columns.filter(column => column.field == "libelleCourt")[0].show == true && 'none' }}>
                    <FilterContainer>
                        <InputFilter
                            placeholder={t("LRYX")}
                            onChange={(e) => inputChangeHandler(e)}
                            value={entitiesFilters?.libelleCourt || ''}
                            name="libelleCourt"
                            type="text"
                            autoComplete="off"
                        />
                    </FilterContainer>
                </TD>
                <TD style={{ display: !columns.filter(column => column.field =="adresseMail")[0].show == true && 'none'}}>
                    <FilterContainer>
                        <InputFilter 
                            placeholder={t("invoiceList:entityCode", "smith@gmail.com")}
                            onChange={(e) => inputChangeHandler(e)} 
                            value={entitiesFilters?.adresseMail || ''} 
                            name="adresseMail" 
                            type="text" 
                            autoComplete="off"
                        />
                    </FilterContainer>
                </TD>
         
                
           
                <TD style={{ display: !columns.filter(column => column.field =="telephoneSupport")[0].show == true && 'none'}}>
                    <FilterContainer>
                        <InputFilter 
                            placeholder={t("Telephone support")}
                            onChange={(e) => inputChangeHandler(e)} 
                            value={entitiesFilters?.telephoneSupport || ''} 
                            name="telephoneSupport" 
                            type="text" 
                            autoComplete="off"
                        />
                    </FilterContainer>
                </TD>
                <TD style={{ display: !columns.filter(column => column.field =="hierarchieBailleur")[0].show == true && 'none'}}>
                    <FilterContainer>
                        <SelectFilter
                            onChange={(e) => inputChangeHandler(e)}
                            value={entitiesFilters?.hierarchieBailleur || ''}
                            name="hierarchieBailleur"
                        >
                            <Option value=""></Option>
                            <Option value="1">{t('tableHead:yes', 'Oui').toUpperCase()}</Option>
                            <Option value="0">{t('tableHead:no', 'Non').toUpperCase()}</Option>
                        </SelectFilter>
                    </FilterContainer>
                </TD>
                <TD style={{ display: !columns.filter(column => column.field == "metadata")[0].show == true && 'none' }}>
                    <FilterContainer>
                        <SelectFilter
                            onChange={(e) => inputChangeHandler(e)}
                            value={entitiesFilters?.Metadata || ''}
                            name="Metadata"
                        >
                            <Option value=""></Option>
                            <Option value="1">{t('tableHead:yes', 'Oui').toUpperCase()}</Option>
                            <Option value="0">{t('tableHead:no', 'Non').toUpperCase()}</Option>
                        </SelectFilter>
                    </FilterContainer>
                </TD>
                {/*<TD style={{display: !columns.filter(column => column.field=="Metadata")[0].show == true && 'none'}}>*/}
                {/*    <FilterContainer>*/}
                {/*        <InputFilter */}
                {/*            placeholder={t("invoiceList:family", "Type")}*/}
                {/*            onChange={(e) => inputChangeHandler(e)} */}
                {/*            value={entitiesFilters?.Metadata || ''} */}
                {/*            name="family" */}
                {/*            type="text" */}
                {/*            autoComplete="off"*/}
                {/*        />*/}
                {/*    </FilterContainer>*/}
                {/*</TD>*/}
                {/*<TD style={{display: !columns.filter(column => column.field=="creationDate")[0].show == true && 'none'}}>*/}
                {/*    <FilterContainer>*/}
                {/*        <DateFilter*/}
                {/*            modalTitle={t("invoiceList:creationDate", "Date de Création")}*/}
                {/*            from={getCreationdate()[0] || ''}*/}
                {/*            to={getCreationdate()[1] || ''}*/}
                {/*            name="creationDate"*/}
                {/*            activeReset={entitiesFilters?.creationDate ? true : false}*/}
                {/*            resetInterval={dateResetHandler}*/}
                {/*            show={show?.creationDate}*/}
                {/*            showModal={dateShowHandler}*/}
                {/*            closeModal={closeModalHandler}*/}
                {/*            dateChange={(date) =>dateChangeHandler(date)}*/}
                {/*        />*/}
                {/*    </FilterContainer>*/}
                {/*</TD>*/}
           
                    <TD>
                    <BtnFilter onClick={() => resetFilters()}>
                            <CTooltip title={"Réinitialiser les filtres"}>

                            <FilterListOffIcon  style={{ color: "#fff" }} />

                            </CTooltip>
                        </BtnFilter>
                    </TD>
            </tr>
        </>
    )
}

export default TableFilters
